import { ButtonHTMLAttributes } from "react";
import Loader from "../loader/Loader";
import { BaseButtonComponent } from "./ButtonComponents";
import { ButtonSizeType, ButtonVariantType } from "./buttonTypes";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    variant: ButtonVariantType;
    size: ButtonSizeType;
    isLoading?: boolean;
};

export const Button = ({ variant, size, isLoading, ...props }: ButtonProps) => (
    <BaseButtonComponent {...props} $variant={variant} $size={size} $isLoading={isLoading}>
        {isLoading && <Loader />}
        {props.children}
    </BaseButtonComponent>
)
